/**
 * queryClient.ts — singleton TanStack Query client for the admin panel.
 *
 * Defaults:
 *   staleTime 30s, gcTime 5min, no focus refetch, retry 1, reconnect refetch on.
 *
 * Domains can override per-query when their freshness profile differs from
 * the default (e.g. dispatcher uses `refetchInterval: 10_000` to keep the
 * live GPS poll cadence; near-static catalogs widen `staleTime`).
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime:    5 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect:   true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
